import React, { FC, useEffect, useState } from "react";
import loginVideoUrls from "../Assets/LogInVideos.json";
import Logo from "../Assets/Logo.svg";
import { Link, useNavigate } from "react-router-dom";
import { Input } from "../Components/ui/input";
import { Button } from "../Components/ui/button";
import { Container, Typography, Box, CircularProgress } from "@mui/material";
import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
import crypto from "crypto-js";
import {
  setForgotPassword,
  setForgotEmail,
  setAccountId,
  setReviewToken,
  setAdminUrl,
  setAdvUrl,
  setAuthUrl,
  setSmsUrl,
  setOperatorUrl,
  setmail,
  setisAuthstate,
  setworkspace,
  setWorkspaceId,
  setIsAdmin,
  setRoleId,
  sethasFetched,
  setAuthenticated,
  setntfyUrl,
  setUserIP,
  setQuickTestUrl
} from "../State/slices/AuthenticationSlice";
import {
  setPermissions,
  setUser_Role_Name,
} from "../State/slices/AdvertiserAccountSlice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../State/store";
import { useToast } from "../Components/ui/use-toast";
import { Toaster } from "../Components/ui/toaster";
import { jwtDecode } from "jwt-decode";

import { Eye, EyeOff } from "lucide-react";

interface DecodedToken {
  email: string;
  action: string;
  wid: string;
  cid: string;
  tid: string;
}

interface DecodedTokenFromCookie {
  email: string;
  exp: number;
  iss: string;
  aud: string;
}

interface CustomSignupFormProps {
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  setAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
  setUserEmailId: React.Dispatch<React.SetStateAction<string>>;
}

const CustomSignupForm: FC<CustomSignupFormProps> = ({
  email,
  setEmail,
  setAuthenticated,
  setUserEmailId,
}) => {
  const navigate = useNavigate();
  const [emailError, setEmailError] = useState<string | null>(null);
  // const hasFetched = useSelector((state: RootState) => state.authentication.hasFetched);
  const [hasFetched, setHasFetched] = useState(false);
  // const authenticated = useSelector((state : RootState) => state.authentication.authenticated);
  // const [passwordError, setPasswordError] = useState<string | null>(null);
  const [password, setPassword] = useState("");
  const [apiUrl, setApiUrl] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [openModal, setOpenModal] = useState(false); // To control modal visibility
  const [newEmail, setNewEmail] = useState(""); // For the email input in the modal
  // const [newPassword, setNewPassword] = useState(''); // For the new password input
  // const [confirmPassword, setConfirmPassword] = useState(''); // For confirm password
  const [changePassword, setChangePassword] = useState(false);
  const [otp, setOtp] = useState<string>(""); // Define the OTP state
  const dispatch = useDispatch();

  const [repasswordError, setRePasswordError] = useState<string | null>(null);
  const forgotMail =
    useSelector((state: RootState) => state.authentication.forgotEmail) || " ";

  const [newPasswordError, setNewPasswordError] = useState(false);
  // const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const toast = useToast();

  const decode: (token: string) => any = jwtDecode as unknown as (
    token: string,
  ) => any;
  const apiUrlAdvAcc = useSelector(
    (state: RootState) => state.authentication.apiURL,
  );
  //
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState<string | null>(null);
  const [confirmPasswordError, setConfirmPasswordError] = useState<
    string | null
  >(null);

  const [showPassword, setShowPassword] = useState(false);

  const reviewData = useSelector(
    (state: RootState) => state.authentication.reviewToken,
  );

  const accountId = useSelector(
    (state: RootState) => state.authentication.account_id,
  );

  const forgotPassword = useSelector(
    (state: RootState) => state.authentication.forgotPassword,
  );

  //
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);
  const [Login, setLogin] = useState("");

  useEffect(() => {
    if (forgotPassword === false) {
    }
  }, [forgotPassword]);

  const handleCancelForgotPassword = () => {
    setChangePassword(false); // Hide the email input for forgot password
    setNewEmail("");
    dispatch(setForgotPassword(false));
  };

  const handleCloseModal = () => {
    setOpenModal(false); // Close the modal
  };

  const handleSubmitUpdatePassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);

    // init as Success (your preference)
    let auditStatus: "Success" | "Failed" = "Success";
    let auditMessage = "Password updated successfully.";

    try {
      // 1) Validation
      if (!newPassword || !confirmPassword) {
        auditStatus = "Failed";
        auditMessage = "Both password fields are required.";
        toast.toast({ title: "Error", description: auditMessage });
      } else if (newPassword !== confirmPassword) {
        auditStatus = "Failed";
        auditMessage = "Passwords do not match.";
        toast.toast({ title: "Error", description: auditMessage });
      } else {
        // 2) API call
        const res = await axios.post(`${apiUrl}/UpdatePassword`, {
          email: forgotMail,
          newPassword: hashPasword(newPassword),
        });

        if (res.data[0]?.Status === "Success") {
          // keep Success
          auditMessage = "Password updated successfully.";
          toast.toast({ title: "Success", description: auditMessage });
          setTimeout(() => {
            dispatch(setForgotPassword(false));
            navigate("/");
          }, 1000);
        } else {
          auditStatus = "Failed";
          auditMessage = "Password update failed.";
          toast.toast({
            title: "Error",
            description: "An error occurred, please try again",
          });
        }
      }
    } catch (err) {
      auditStatus = "Failed";
      auditMessage = "Password update failed (exception).";
      console.error("UpdatePassword error:", err);
      toast.toast({
        title: "Error",
        description: "An error occurred, please try again",
      });
    } finally {
      debugger;
      let accountId: number | null = 0;
      try {
        const afterData = JSON.stringify({
          email: forgotMail ?? null,
          event: "Password Updated",
          password: hashPasword(newPassword),
          timestamp: new Date().toISOString(),
        });
        accountId = await getAccountId(forgotMail, apiUrl);
        if (!accountId) {
          console.error("AccountId not found");
        }

        await axios.post(`${apiUrl}/InsertUpdatePasswordAuditHistory`, {
          emailId: forgotMail ?? null,
          userAccountId: accountId ?? null,
          campaignId: null,
          advertiserWorkspaceId: null,
          action: "Update Password",
          actionPage: "SignIn page",
          status: auditStatus,

          afterData,

          comments: auditMessage,
        });
      } catch (e) {
        console.warn("Audit insert failed", e);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleForgotButtonClick = () => {
    setChangePassword(true);
  };

const handleForgotPassword = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setIsLoading(true);
    setChangePassword(true);
    dispatch(setForgotEmail(newEmail));
    setEmailError(null);
    let ipAddress = "";
    try {
      const trackRes = await axios.post(`${apiUrl}/TrackVisit`);
      ipAddress = trackRes.data.ip;
      localStorage.setItem("UserIP", ipAddress);
      dispatch(setUserIP(ipAddress));
    } catch (trackErr) {
      console.error("Error calling track API:", trackErr);
    }
    const auditDto = {
      UserAccountId: accountId || null, // Use accountId from Redux or null
      CampaignId: 0,
      AdvertiserWorkspaceId: null, // May be null if not yet set
      Action: "Forgot Password",
      ActionPage: "SignIn page",
      Status: "", // Will be set dynamically
      AfterData: "", // Will be set dynamically

      Comments: "", // Will be set dynamically
    };
    try {
      const response = await axios.post(`${apiUrl}/ForgotPassword`, {
        email: newEmail,
      });

      console.log("ForgotPassword Response:", response);

      if (response.data[0]?.Status === "Success") {
        auditDto.Status = "Success";
        auditDto.AfterData = JSON.stringify({
          newEmail,
          response: response.data.status_Description,
        });
        auditDto.Comments = `OTP sent successfully to ${newEmail}.`;
        toast.toast({
          title: "Success",
          description: "OTP sent to email",
        });
        const Close = () => {
          setIsLoading(false);
          setUserEmailId(newEmail);
          dispatch(setForgotPassword(true));
          navigate("/otpverify", { state: { newEmail } });
        };
        Close();
      } else {
        const errorMessage = response.data[0]?.Status_Description;
        console.log(errorMessage);
        auditDto.Status = "Failure";
        auditDto.AfterData = JSON.stringify({ newEmail, response: response.data });
        auditDto.Comments = `Failed to send OTP to ${newEmail}: ${
          errorMessage || "Unknown error"
        }.`;
        if (errorMessage === "Email does not exist.") {
          const Close = () => {
            setIsLoading(false);
          };
          Close();
          toast.toast({
            title: "Error",
            description: "Email does not exist",
          });
        } else {
          const Close = () => {
            setIsLoading(false);
          };
          Close();
          toast.toast({
            title: "Error",
            description: "Email not found, Please create an account first",
          });
        }
      }
    } catch (error) {
      auditDto.Status = "Failure";
      auditDto.AfterData = JSON.stringify({ newEmail });
      auditDto.Comments = `An error occurred.`;
      console.error("Error during ForgotPassword API call:", error);
      toast.toast({
        title: "Error",
        description: "An error occurred",
      });
      console.log("Error ");
      setIsLoading(false);
    } finally {
      debugger;
      let accountId: number | null = 0;
      try {
        accountId = await getAccountId(newEmail, apiUrl);
        if (!accountId) {
          console.error("AccountId not found");
        }
        await axios.post(`${apiUrlAdvAcc}/InsertOverAllAuditHistory`, auditDto);
      } catch (auditError) {
        console.error(
          "Failed to insert audit history for Forgot Password:",
          auditError,
        );
      }
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      if (hasFetched) return; // If already fetched, exit early

      try {
        debugger;
        // Fetch configuration data from config.json
        const response = await fetch("/config.json");
        const config = await response.json();

        setHasFetched(true);

        // Dispatch actions after configuration is fetched
        setApiUrl(config.API_URL);
        dispatch(setAuthUrl(config.API_URL));
        dispatch(setAdvUrl(config.ApiUrlAdvAcc));
        dispatch(setAdminUrl(config.ApiUrlAdminAcc));
        dispatch(setSmsUrl(config.SmsUrlAdminAcc));
        dispatch(setOperatorUrl(config.OperatorUrl));
        dispatch(setntfyUrl(config.NtfyUrl));
        dispatch(setQuickTestUrl(config.QuickTestUrl));

        // Get token from cookie
        const resetToken = sessionStorage.getItem("ResetToken");
        if (forgotPassword || resetToken) {
          // We are in forgot/reset flow — do NOT read cookie or navigate to dashboard
          return;
        }

        const getAuthTokenFromCookie = () => {
          const pair = document.cookie
            .split("; ")
            .find((r) => r.startsWith("AuthToken="));
          return pair ? pair.split("=")[1] : null;
        };

        const tokenFromCookie = getAuthTokenFromCookie();
        let decodedtokenFromCookie = null;

        if (tokenFromCookie) {
          setAuthenticated(true);
          try {
            // Decode the token from the cookie
            decodedtokenFromCookie =
              jwtDecode<DecodedTokenFromCookie>(tokenFromCookie);
            console.log("Decoded Token from Cookie:", decodedtokenFromCookie);

            const currentTime = Math.floor(Date.now() / 1000); // Current timestamp in seconds
            if (decodedtokenFromCookie.exp < currentTime) {
              console.log("Token expired");
            } else {
              dispatch(setmail(decodedtokenFromCookie.email));
              dispatch(setisAuthstate(true));
              sessionStorage.setItem("otpVerified", "true");
              sessionStorage.setItem("email", decodedtokenFromCookie.email);
              setLogin("Login"); // Update the login state
            }
          } catch (error) {
            console.error("Error decoding token from cookie:", error);
          }
        } else {
          console.log("No token found in cookie...");
        }

        debugger;
        // Handle the token in the URL
        let reviewTokenData = null;
        const params = new URLSearchParams(window.location.search);
        console.log("params: " + window.location.search);
        const token = params.get("token");

        debugger;
        if (token) {
          const code = jwtDecode<DecodedToken>(token);
          console.log("Action raw:", code.action);
          console.log("Action length:", code.action.length);
          console.log("Expected length:", "operator_welcome_review".length);
        }

        if (token) {
          debugger;
          const decoded = jwtDecode<DecodedToken>(token);
          console.log("Action raw:", decoded.action);
          console.log("Action length:", decoded.action.length);
          console.log("Expected length:", "operator_welcome_review".length);
          switch (decoded.action) {
            case "admin_review":
              reviewTokenData = {
                email: decoded.email,
                action: decoded.action,
                wid: Number(decoded.wid),
                cid: Number(decoded.cid),
                tid: 0,
              };
              dispatch(setReviewToken(reviewTokenData));
              break;

            case "operator_review":
              reviewTokenData = {
                email: decoded.email,
                action: decoded.action,
                wid: Number(decoded.wid),
                cid: Number(decoded.cid),
                tid: 0,
              };
              dispatch(setReviewToken(reviewTokenData));
              break;

            case "operator_welcome_review":
              reviewTokenData = {
                email: decoded.email,
                action: decoded.action,
                wid: Number(decoded.wid),
                cid: 0,
                tid: Number(decoded.tid),
              };
              dispatch(setReviewToken(reviewTokenData));
              break;

            case "operator_welcome_update":
              reviewTokenData = {
                email: decoded.email,
                action: decoded.action,
                wid: Number(decoded.wid),
                cid: 0,
                tid: Number(decoded.tid),
              };
              dispatch(setReviewToken(reviewTokenData));
              break;

            case "advertiser_update":
              reviewTokenData = {
                email: decoded.email,
                action: decoded.action,
                wid: Number(decoded.wid),
                cid: Number(decoded.cid),
                tid: 0,
              };
              dispatch(setReviewToken(reviewTokenData));
              break;

            case "admin_welcome_review":
              reviewTokenData = {
                email: decoded.email,
                action: decoded.action,
                wid: Number(decoded.wid),
                cid: 0,
                tid: Number(decoded.tid),
              };
              dispatch(setReviewToken(reviewTokenData));
              break;

            default:
              console.log(`unknown action: ${decoded.action} on token`);
              break;
          }
        } else {
          console.log("No token found....");
        }

        // Make sure to call handlePostOTP only after setting state and fetching data
        if (decodedtokenFromCookie && decodedtokenFromCookie.email) {
          setLogin("Login"); // Ensure that login state is updated first
          const userAccountId = await getAccountId(
            decodedtokenFromCookie.email,
            config.API_URL,
          );
          await handlePostOTP(
            decodedtokenFromCookie.email,
            config.API_URL,
            "Login",
            reviewTokenData,
            userAccountId,
          ); // Call with the updated values
        }
      } catch (error) {
        console.error("Error loading config:", error);
        toast.toast({
          title: "Error",
          description: "Something went wrong, please try again.",
        });
      }
    };

    // Ensure fetchData runs only once by adding an empty dependency array
    fetchData();
    dispatch(sethasFetched(true)); // Call the async function inside useEffect
  }, [hasFetched]); // Empty dependency array ensures this effect runs only once

  const getAccountId = async (
    email: string,
    apiUrl: string,
  ): Promise<number | null> => {
    debugger;
    const Account_response = await axios.post(
      `${apiUrl}/GetUserAccountByEmail`,
      {
        email: email,
      },
    );
    if (Account_response.data[0]?.Status === "Success") {
      localStorage.setItem("userid", Account_response.data[0]?.User_Account_Id);
      const userAccountId = Account_response.data[0]?.User_Account_Id;
      console.log("Account_ID :", userAccountId);
      dispatch(setAccountId(userAccountId));
      return Number(userAccountId);
    } else {
      console.log("User account ID not found");
      return null;
    }
  };

  const handlePostOTP = async (
    email: string,
    apiUrl: string,
    Login: string,
    reviewTokenData?: any,
    userAccountIdParam?: number | null,
  ) => {
    if (Login === "Login") {
      try {
        debugger;
        const workspaceResponse = await axios.get(
          `${apiUrl}/GetWorkspaceNameByEmail?EmailId=${email}`,
        );
        if (
          workspaceResponse.status === 200 &&
          workspaceResponse.data.status === "Success"
        ) {
          const { workspace_name, workspace_type, workspace_id } =
            workspaceResponse.data.workspaceName;

          dispatch(setmail(email));
          dispatch(setworkspace(workspace_name));
          dispatch(setWorkspaceId(workspace_id));

          sessionStorage.setItem("workspace_id", workspace_id.toString());

          const adminResponse = await axios.get(
            `${apiUrl}/CheckIfAdmin?EmailId=${email}`,
          );
          const isAdmin = adminResponse.data.isAdmin;
          dispatch(setIsAdmin(adminResponse.data.isAdmin));
          const effectiveAccountId =
            userAccountIdParam ??
            Number(localStorage.getItem("userid")) ?? // fallback if we set it earlier
            0;
          await fetchRoleDetails(effectiveAccountId, workspace_id, apiUrl);

          // Wait for review data to be populated before navigating
          if (reviewTokenData?.action === "admin_review") {
            if (isAdmin === true) {
              // User is admin, proceed to admin approval page
              navigate("/adminNavbar/admincampaignapproval", {
                state: {
                  campaignId: reviewTokenData.cid,
                  campaignWorkspaceId: reviewTokenData.wid,
                  authenticated: true,
                },
              });
            } else {
              // User is not admin, redirect to login for admin access
              console.log(
                "User is not admin, requiring login for admin access",
              );

              // Store the review token data in session storage for later use
              sessionStorage.setItem(
                "pendingAdminReview",
                JSON.stringify(reviewTokenData),
              );

              // Clear the current authentication state
              sessionStorage.removeItem("otpVerified");
              sessionStorage.removeItem("email");
              document.cookie =
                "AuthToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

              // Show toast message
              toast.toast({
                title: "Admin Access Required",
                description:
                  "Please log in with admin credentials to access the campaign approval page.",
              });

              // Navigate back to login page
              navigate("/", {
                state: {
                  requireAdminLogin: true,
                  message: "Admin login required for campaign approval access",
                },
              });
            }
          } else if (reviewTokenData?.action === "operator_review") {
            debugger;
            // Get the email from cookie token for comparison
            const getAuthTokenFromCookie = () => {
              const pair = document.cookie
                .split("; ")
                .find((r) => r.startsWith("AuthToken="));
              return pair ? pair.split("=")[1] : null;
            };

            const tokenFromCookie = getAuthTokenFromCookie();
            let cookieEmail = email; // Default to the email parameter

            if (tokenFromCookie) {
              try {
                const decodedTokenFromCookie =
                  jwtDecode<DecodedTokenFromCookie>(tokenFromCookie);
                cookieEmail = decodedTokenFromCookie.email;
              } catch (error) {
                console.error("Error decoding token from cookie:", error);
              }
            }

            // Check if the review token email matches the authenticated user's email
            // Note: For operator_review, the email might not be in the token, so we need to handle this case
            if (reviewTokenData.email === cookieEmail) {
              const operator_mapping_id = await getOperatorMappingId(
                reviewTokenData.cid,
                workspace_id,
                apiUrl,
              );
              if (operator_mapping_id !== null) {
                navigate("/operatorNavbar/operatorcampaignapproval", {
                  state: {
                    campaignId: reviewTokenData.cid,
                    operatorMappingId: operator_mapping_id,
                    authenticated: true,
                  },
                });
              } else {
                toast.toast({
                  title: "Access Denied",
                  description:
                    "You are not authorized to review this campaign. Please log in with the correct account.",
                });
                navigate("/", {
                  state: {
                    requireOperatorLogin: true,
                    message:
                      "Operatr login required for campaign approval access",
                  },
                });
              }
            } else {
              // Email mismatch - show error and redirect to dashboard
              toast.toast({
                title: "Access Denied",
                description:
                  "You are not authorized to review this campaign. Please log in with the correct account.",
              });
              navigate("/", {
                state: {
                  requireOperatorLogin: true,
                  message:
                    "Operatr login required for campaign approval access",
                },
              });
            }
          } else if (reviewTokenData?.action === "operator_welcome_review") {
            debugger;
            // Get the email from cookie token for comparison
            const getAuthTokenFromCookie = () => {
              const pair = document.cookie
                .split("; ")
                .find((r) => r.startsWith("AuthToken="));
              return pair ? pair.split("=")[1] : null;
            };

            const tokenFromCookie = getAuthTokenFromCookie();
            let cookieEmail = email; // Default to the email parameter

            if (tokenFromCookie) {
              try {
                const decodedTokenFromCookie =
                  jwtDecode<DecodedTokenFromCookie>(tokenFromCookie);
                cookieEmail = decodedTokenFromCookie.email;
              } catch (error) {
                console.error("Error decoding token from cookie:", error);
              }
            }

            // Check if the review token email matches the authenticated user's email
            // Note: For operator_review, the email might not be in the token, so we need to handle this case
            if (reviewTokenData.email === cookieEmail) {
              // const operator_mapping_id = await getOperatorMappingId(
              //   reviewTokenData.cid,
              //   workspace_id,
              //   apiUrl,
              // );
              if (reviewTokenData.tid !== 0) {
                navigate("/operatorNavbar/templatelist", {
                  state: {
                    templateId: reviewTokenData.tid,
                    action: reviewTokenData.action,
                    authenticated: true,
                  },
                });
              } else {
                toast.toast({
                  title: "Access Denied",
                  description:
                    "You are not authorized to review this campaign. Please log in with the correct account.",
                });
                navigate("/", {
                  state: {
                    requireOperatorLogin: true,
                    message:
                      "Operatr login required for template approval access",
                  },
                });
              }
            } else {
              // Email mismatch - show error and redirect to dashboard
              toast.toast({
                title: "Access Denied",
                description:
                  "You are not authorized to review this campaign. Please log in with the correct account.",
              });
              navigate("/", {
                state: {
                  requireOperatorLogin: true,
                  message:
                    "Operatr login required for campaign approval access",
                },
              });
            }
          } else if (reviewTokenData?.action === "operator_welcome_update") {
            debugger;
            // Get the email from cookie token for comparison
            const getAuthTokenFromCookie = () => {
              const pair = document.cookie
                .split("; ")
                .find((r) => r.startsWith("AuthToken="));
              return pair ? pair.split("=")[1] : null;
            };

            const tokenFromCookie = getAuthTokenFromCookie();
            let cookieEmail = email; // Default to the email parameter

            if (tokenFromCookie) {
              try {
                const decodedTokenFromCookie =
                  jwtDecode<DecodedTokenFromCookie>(tokenFromCookie);
                cookieEmail = decodedTokenFromCookie.email;
              } catch (error) {
                console.error("Error decoding token from cookie:", error);
              }
            }

            // Check if the review token email matches the authenticated user's email
            // Note: For operator_review, the email might not be in the token, so we need to handle this case
            if (reviewTokenData.email === cookieEmail) {
              // const operator_mapping_id = await getOperatorMappingId(
              //   reviewTokenData.cid,
              //   workspace_id,
              //   apiUrl,
              // );
              if (reviewTokenData.tid !== 0) {
                navigate("/operatorNavbar/templatelist", {
                  state: {
                    templateId: reviewTokenData.tid,
                    action: reviewTokenData.action,
                    authenticated: true,
                  },
                });
              } else {
                toast.toast({
                  title: "Access Denied",
                  description:
                    "You are not authorized to review this template. Please log in with the correct account.",
                });
                navigate("/", {
                  state: {
                    requireOperatorLogin: true,
                    message:
                      "Operatr login required for campaign approval access",
                  },
                });
              }
            } else {
              // Email mismatch - show error and redirect to dashboard
              toast.toast({
                title: "Access Denied",
                description:
                  "You are not authorized to review this campaign. Please log in with the correct account.",
              });
              navigate("/", {
                state: {
                  requireOperatorLogin: true,
                  message:
                    "Operatr login required for template approval access",
                },
              });
            }
          }  else if (reviewTokenData?.action === "admin_welcome_review") {
            const getAuthTokenFromCookie = () => {
              const pair = document.cookie
                .split("; ")
                .find((r) => r.startsWith("AuthToken="));
              return pair ? pair.split("=")[1] : null;
            };

            const tokenFromCookie = getAuthTokenFromCookie();
            let cookieEmail = email; // Default to the email paramete
            if (reviewTokenData.email === cookieEmail) {
              if (isAdmin === true) {
                // User is admin, proceed to admin approval page
                navigate("/adminNavbar/templates", {
                  state: {
                    template_id: reviewTokenData.tid,
                    workspace_id: reviewTokenData.wid,
                    mode: "edit",
                    authenticated: true,
                  },
                });
              } else {
                // User is not admin, redirect to login for admin access
                console.log(
                  "User is not admin, requiring login for admin access",
                );

                // Store the review token data in session storage for later use
                // sessionStorage.setItem(
                //   "pendingAdminReview",
                //   JSON.stringify(reviewTokenData),
                // );

                // Clear the current authentication state
                sessionStorage.removeItem("otpVerified");
                sessionStorage.removeItem("email");
                document.cookie =
                  "AuthToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

                // Show toast message
                toast.toast({
                  title: "Admin Access Required",
                  description:
                    "Please log in with admin credentials to access the campaign approval page.",
                });

                // Navigate back to login page
                navigate("/", {
                  state: {
                    requireAdminLogin: true,
                    message:
                      "Admin login required for campaign approval access",
                  },
                });
              }
            } else {
              // Show toast message
              toast.toast({
                title: "Admin Access Required",
                description:
                  "Please log in with admin credentials to access the template approval page.",
              });

              // Navigate back to login page
              navigate("/", {
                state: {
                  requireAdminLogin: true,
                  message: "Admin login required for campaign approval access",
                },
              });
            }
          } else if (reviewTokenData?.action === "advertiser_update") {
            // Get the email from cookie token for comparison
            const getAuthTokenFromCookie = () => {
              const pair = document.cookie
                .split("; ")
                .find((r) => r.startsWith("AuthToken="));
              return pair ? pair.split("=")[1] : null;
            };

            const tokenFromCookie = getAuthTokenFromCookie();
            let cookieEmail = email; // Default to the email parameter

            if (tokenFromCookie) {
              try {
                const decodedTokenFromCookie =
                  jwtDecode<DecodedTokenFromCookie>(tokenFromCookie);
                cookieEmail = decodedTokenFromCookie.email;
              } catch (error) {
                console.error("Error decoding token from cookie:", error);
              }
            }

            // Check if the review token email matches the authenticated user's email
            if (reviewTokenData.email === cookieEmail) {
              const campaignStatusResponse = await axios.get(
                `${apiUrl}/GetCampaignAdminApproval?CampaignId=${reviewTokenData.cid}`,
              );
              if (
                campaignStatusResponse.data.status === "Success" &&
                (campaignStatusResponse.data.adminApproval === "pending" ||
                  campaignStatusResponse.data.adminApproval === "rejected")
              ) {
                navigate("/navbar/createcampaign", {
                  state: {
                    campaignId: reviewTokenData.cid,
                    authenticated: true,
                  },
                });
              } else {
                toast.toast({
                  title: "Status",
                  description: "The Campaign is already resubmitted.",
                });
                navigateWithDelay(
                  workspace_type === "Telecom Operator"
                    ? "/operatorNavbar/dashboard"
                    : "/navbar/dashboard",
                  {
                    state: {
                      path: workspace_name,
                      email,
                      route: "Dashboard",
                      authenticated: true,
                    },
                  },
                );
              }
            } else {
              // Email mismatch - show error and redirect to dashboard
              toast.toast({
                title: "Access Denied",
                description:
                  "You are not authorized to update this campaign. Please log in with the correct account.",
              });
              toast.toast({
                title: "Access Denied",
                description:
                  "You are not authorized to review this campaign. Please log in with the correct account.",
              });
              navigate("/", {
                state: {
                  requireAdvertiserLogin: true,
                  message:
                    "Advertiser login required for campaign approval access",
                },
              });
            }
          }
          else {
            navigateWithDelay(
              workspace_type === "Telecom Operator"
                ? "/operatorNavbar/dashboard"
                : "/navbar/dashboard",
              {
                state: {
                  path: workspace_name,
                  email,
                  route: "Dashboard",
                  authenticated: true,
                },
              }
            );
          }
        
        }
      } catch (error) {
        console.error("Error fetching workspace:", error);
      }
    }
  };

  // const checkIfAdmin = async (email: string, apiUrl: string) => {
  //         try {
  //             const response = await axios.get(`${apiUrl}/CheckIfAdmin?EmailId=${email}`);
  //             if (response.data.status === "Success") {
  //                 dispatch(setIsAdmin(response.data.isAdmin));
  //             } else {
  //                 console.log("CheckIfAdmin API error");
  //             }
  //         } catch (error) {
  //             console.error("Error checking admin status:", error);
  //         }
  //     };

  const fetchRoleDetails = async (
    accountId: number,
    workspaceId: number,
    apiUrl: string,
  ) => {
    try {
      const response = await axios.get(
        `${apiUrl}/GetUserWorkspaceRoleDetails/GetUserWorkspaceRoleDetails?accountId=${accountId}&workspaceId=${workspaceId}`,
      );

      if (response.data.status === "Success") {
        const roleId = response.data.userWorkspaceRoleDetails[0]?.roleId;
        dispatch(setRoleId(roleId));

        // Store accountId in sessionStorage
        // setSessionDataWithExpiry("accountId", accountId.toString(), 60);
        sessionStorage.setItem("accountId", accountId.toString());

        if (roleId) {
          await fetchPermissions(roleId, apiUrl);
        }
      } else {
        console.log("GetUserWorkspaceRoleDetails API error");
      }
    } catch (error) {
      console.error("Error fetching user workspace role details:", error);
    }
  };

  const fetchPermissions = async (roleId: string, apiUrl: string) => {
    try {
      const response = await axios.get(
        `${apiUrl}/GetPermissionsByRoleId?RoleID=${roleId}`,
      );
      if (response.data.status === "Success") {
        const permissions = JSON.parse(response.data.roleDetails.permissions);
        const role_name = response.data.roleDetails.roleName;
        dispatch(setPermissions(permissions));
        dispatch(setUser_Role_Name(role_name));
      } else {
        console.log("GetPermissionsByRoleId API error");
      }
    } catch (error) {
      console.error("Error fetching permissions:", error);
    }
  };

  const getOperatorMappingId = async (
    campaign_id: number,
    operator_id: number,
    apiUrl: string,
  ) => {
    try {
      debugger;
      const response = await axios.post(
        `${apiUrl}/GetOperatorMappingId?campaign_id=${campaign_id}&workspace_id=${operator_id}`,
      );
      if (response.data.status === "Success") {
        if (response.data.operatorMappingId !== null) {
          return Number(response.data.operatorMappingId);
        } else {
          return null;
        }
      } else {
        return null;
      }
    } catch (err) {
      console.error(
        `Error in fetching operator_mapping_id for campaign_id: ${campaign_id}`,
      );
    }
  };

  // const handleInvitation = async (email: string) => {
  //     try {
  //         const decoded = jwtDecode<DecodedToken>(token);
  //         const workspaceId = decoded.WorkspaceId;
  //         dispatch(setWorkspaceId(workspaceId));
  //         navigate("/personalinfo", { state: { path: "", email } });

  //     } catch (error) {
  //         console.error("Error handling invitation:", error);
  //         toast.toast({
  //             title: "Error",
  //             description: "Something went wrong. Please try again.",
  //         });
  //     }
  // };

  const navigateWithDelay = (path: string, state: any) => {
    navigate(path, state); // Remove setTimeout unless there's a specific reason for the delay
  };

  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  function hashPasword(pass: string): string {
    return crypto.SHA256(pass).toString();
  }

const handleNext = async (e: React.FormEvent): Promise<void> => {
  const isLogin = "Login";
  setIsLoading(true);
  e.preventDefault();

  // ✅ Audit variables
  let auditStatus = "Failure";
  let auditComments = "";
  let resolvedUserId: string | null = null;

  const fireAudit = async () => {
    try {
      await axios.post(`${apiUrl}/InsertOverAllAuditHistory`, {
        UserAccountId: resolvedUserId ?? null,
        CampaignId: null,
        AdvertiserWorkspaceId: null,
        Action: "Sign In",
        ActionPage: "Sign In page",
        Status: auditStatus,
        BeforeData: null,
        AfterData: JSON.stringify({ email }),
        Comments: auditComments,
      });
    } catch (auditError) {
      console.error("Audit logging failed:", auditError);
    }
  };

  if (!validateEmail(email)) {
    setEmailError("Please enter a valid email address");
    setIsLoading(false);
    return;
  }
  setEmailError(null);

  if (password.trim() === "") {
    setPasswordError("Password cannot be empty");
    setIsLoading(false);
    return;
  }

  setPasswordError(null);

  try {
    const checkStatusRes = await axios.post(
      `${apiUrl}/CheckAccountEnableorDisable`,
      { email }
    );

    const status = checkStatusRes.data.status;
    const description = checkStatusRes.data.status_Description;

    if (status === "Failure") {
      auditStatus = "Failure";
      auditComments = `Access Denied - ${description}`;

      toast.toast({
        title: "Access Denied",
        description: description,
      });

      setIsLoading(false);
      return;
    }
  } catch (error) {
    console.error("Account check failed:", error);

    auditStatus = "Failure";
    auditComments = "Failed to validate account status. Please try again.";

    toast.toast({
      title: "Error",
      description: auditComments,
    });

    setIsLoading(false);
    return;
  }

  try {
    const response = await axios.post(`${apiUrl}/UserLogin`, {
      email: email,
      phoneNumber: "string",
      emailVerified: "string",
      phoneVerified: "string",
      password: hashPasword(password),
    });

    if (response.data[0]?.Status === "Success") {
      const Account_response = await axios.post(
        `${apiUrl}/GetUserAccountByEmail`,
        { email }
      );

      if (Account_response.data[0]?.Status === "Success") {
        const userAccountId = Account_response.data[0]?.User_Account_Id;

        localStorage.setItem("userid", userAccountId);
        dispatch(setAccountId(userAccountId));
        resolvedUserId = userAccountId;

        console.log("Account_ID :", userAccountId);
      } else {
        console.log("User account ID not found");
      }

      auditStatus = "Success";
      auditComments = "OTP sent to your email";

      toast.toast({
        title: "Success",
        description: "OTP sent to your email",
      });

      const Close = () => {
        setAuthenticated(true);
        setUserEmailId(email);
        setIsLoading(false);
        navigate("/otpverify", { state: { isLogin, email } });
      };
      Close();

    } else {
      const errorMessage = response.data[0]?.Status_Description;

      if (errorMessage === "Password verification failed.") {
        auditStatus = "Failure";
        auditComments = "Invalid password";

        setIsLoading(false);

        toast.toast({
          title: "Error",
          description: "Invalid password",
        });

      } else if (
        errorMessage === "Email does not exist." ||
        errorMessage === "Email not found. Please create an account first"
      ) {
        auditStatus = "Failure";
        auditComments =
          "Email not found. Please create an account first.";

        setIsLoading(false);

        toast.toast({
          title: "Error",
          description:
            "Email not found. Please create an account first.",
        });

      } else {
        auditStatus = "Failure";
        auditComments = "Please check your network connection";

        setIsLoading(false);

        toast.toast({
          title: "Error",
          description: "Please check your network connection",
        });
      }
    }
  } catch (error) {
    console.error("Error during API call:", error);

    auditStatus = "Failure";
    auditComments = "Something went wrong, please try again";

    toast.toast({
      title: "Error",
      description: "Something went wrong, please try again",
    });

    setIsLoading(false);
  } finally {
    // ✅ Always fire audit
    await fireAudit();
  }
};


  const validatePassword = (pass: string): void => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    if (!passwordRegex.test(pass)) {
      setPasswordError(
        "Password must be at least 8 characters long, with at least one uppercase letter, one lowercase letter, one number, and one special character (@, $, !, %, *, ?, &).",
      );
    } else {
      setPasswordError(null); // Clear error if password is valid
    }
  };

  const reValidatePassword = (confirmPass: string): void => {
    if (confirmPass !== newPassword) {
      setConfirmPasswordError("Passwords do not match.");
    } else {
      setConfirmPasswordError(null); // Clear the error if passwords match
    }
  };

  return (
    <Container maxWidth="xs" style={{ width: "400px" }}>
      <Toaster />
      {isLoading && (
        <div className="loading-overlay">
          <CircularProgress color="primary" />
        </div>
      )}

      {forgotPassword ? (
        // Password Reset Section (If forgotPassword is true)
        <Box
          component="form"
          onSubmit={handleSubmitUpdatePassword}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h5"
            gutterBottom
            style={{
              textAlign: "center",
              fontWeight: 600,
              fontSize: "20px",
              color: "#09090B",
            }}
          >
            Set New Password
          </Typography>
          <Typography
            variant="body2"
            style={{
              textAlign: "center",
              color: "#71717A",
              fontSize: "14px",
              paddingTop: "8px",
            }}
          >
            Enter your new password below
          </Typography>

          <div className="relative">
            <Input
              required
              type={showNewPassword ? "text" : "password"}
              placeholder="New Password"
              className="w-[350px] h-[36px] border-[#E4E4E7] rounded-[7px] mt-2 pr-10 custom-password"
              value={newPassword}
              onChange={(e) => {
                const value = e.target.value;
                setNewPassword(value); // Update new password state
                validatePassword(value); // Trigger validation for new password
              }}
            />
            <button
              type="button"
              onClick={() => setShowNewPassword((prev) => !prev)}
              className="absolute right-3 top-[60%] transform -translate-y-[50%] text-gray-500"
            >
              {showNewPassword ? (
                <Eye style={{ width: "14px", height: "14px" }} />
              ) : (
                <EyeOff style={{ width: "14px", height: "14px" }} />
              )}
            </button>
          </div>

          {passwordError && (
            <Typography
              color="error"
              variant="body2"
              sx={{ textAlign: "center" }}
            >
              {passwordError}
            </Typography>
          )}

          <div className="relative">
            <Input
              required
              type={showRePassword ? "text" : "password"}
              placeholder="Confirm New Password"
              className="w-[350px] h-[36px] border-[#E4E4E7] rounded-[7px] mt-2 pr-10 custom-password"
              value={confirmPassword}
              onChange={(e) => {
                const value = e.target.value;
                setConfirmPassword(value); // Update confirm password state
                reValidatePassword(value); // Trigger validation for confirm password
              }}
            />
            <button
              type="button"
              onClick={() => setShowRePassword((prev) => !prev)}
              className="absolute right-3 top-[60%] transform -translate-y-[50%] text-gray-500"
            >
              {showRePassword ? (
                <Eye style={{ width: "14px", height: "14px" }} />
              ) : (
                <EyeOff style={{ width: "14px", height: "14px" }} />
              )}
            </button>
          </div>

          {confirmPasswordError && (
            <Typography
              color="error"
              variant="body2"
              sx={{ textAlign: "center" }}
            >
              {confirmPasswordError}
            </Typography>
          )}

          <Box
            display="flex"
            mt={2}
            justifyContent="space-between"
            width="100%"
          >
            <Button
              onClick={handleCancelForgotPassword}
              className="w-[170px]"
              style={{ backgroundColor: "#E4E4E7", color: "#09090B" }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="w-[170px]"
              style={{ backgroundColor: "#007AFF", color: "#fff" }}
            >
              Submit
            </Button>
          </Box>
        </Box>
      ) : changePassword ? (
        // Change Password Section (If changePassword is true and forgotPassword is false)
        <Box
          component="form"
          onSubmit={handleForgotPassword}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h5"
            gutterBottom
            style={{
              textAlign: "center",
              fontWeight: 600,
              fontSize: "20px",
              color: "#09090B",
            }}
          >
            Reset Your Password
          </Typography>
          <Typography
            variant="body2"
            style={{
              textAlign: "center",
              color: "#71717A",
              fontSize: "14px",
              paddingTop: "8px",
            }}
          >
            Enter your email to reset your password
          </Typography>
          <Input
            required
            type="email"
            placeholder="Enter your email"
            className="w-[350px] h-[36px] border-[#E4E4E7] rounded-[7px] mt-2"
            value={newEmail}
            onChange={(e) => setNewEmail(e.target.value)}
          />
          <Box
            display="flex"
            mt={2}
            justifyContent="space-between"
            width="100%"
          >
            <Button
              onClick={handleCancelForgotPassword}
              className="w-[170px]"
              style={{ backgroundColor: "#E4E4E7", color: "#09090B" }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="w-[170px]"
              style={{ backgroundColor: "#007AFF", color: "#fff" }}
            >
              Submit
            </Button>
          </Box>
        </Box>
      ) : (
        // Login Section (If both forgotPassword and changePassword are false)
        <Box
          component="form"
          onSubmit={handleNext}
          style={{ display: "flex", flexDirection: "column" }}
        >
          <Typography
            variant="h4"
            gutterBottom
            style={{
              textAlign: "center",
              fontWeight: 600,
              fontSize: "24px",
              color: "#09090B",
              marginBottom: 0,
            }}
          >
            Log in to TravelAd
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            style={{
              textAlign: "center",
              color: "#71717A",
              fontSize: "14px",
              paddingTop: "8px",
            }}
          >
            Enter your email below to access your account
          </Typography>
          <Box className="mt-6 space-y-2">
            <Input
              required
              type="email"
              placeholder="name@example.com"
              className="w-[350px] h-[36px] border-[#E4E4E7] custom-placeholder rounded-[7px]"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <Typography
              color="error"
              variant="body2"
              style={{ textAlign: "center" }}
            >
              {emailError}
            </Typography>

            {/* Password Input with Show/Hide Icon */}
            <div className="relative">
              <Input
                required
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                className="w-[350px] h-[36px] border-[#E4E4E7] custom-placeholder rounded-[7px] pr-10 custom-password" // Add padding-right for the icon
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                className="absolute right-3 top-[50%] transform -translate-y-[50%] text-gray-500"
              >
                {showPassword ? (
                  <Eye style={{ width: "14px", height: "14px" }} />
                ) : (
                  <EyeOff style={{ width: "14px", height: "14px" }} />
                )}
              </button>
            </div>

            <Typography
              color="error"
              variant="body2"
              style={{ textAlign: "center" }}
            >
              {passwordError}
            </Typography>
          </Box>

          <Button
            type="submit"
            className="w-[350px] h-[36px] mt-0"
            style={{ backgroundColor: "#007AFF", color: "#fff" }}
            disabled={isLoading}
          >
            {isLoading ? "Logging in..." : "Log in with company email"}
          </Button>

          {/* Forgot Password Link */}
          <Box textAlign="center" mt={1}>
            <Link
              to="#"
              onClick={handleForgotButtonClick} // Open the modal when clicked
              className="underline text-gray"
              style={{ fontSize: "14px", color: "#007AFF" }}
            >
              Forgot Password
            </Link>
          </Box>

          <Box
            display="flex"
            style={{ width: "100%", justifyContent: "center" }}
            className="mt-5"
          >
            <Typography
              variant="body2"
              style={{
                textAlign: "center",
                color: "#71717A",
                fontSize: "14px",
                maxWidth: "300px",
              }}
            >
              By clicking continue, you agree to <br /> our{" "}
              <Link to="#" className="underline text-gray">
                Terms of Service
              </Link>{" "}
              and{" "}
              <Link to="#" className="underline text-gray">
                Privacy Policy
              </Link>
              .
            </Typography>
          </Box>
        </Box>
      )}
    </Container>
  );
};

const SignInPage: FC<{
  setAuthenticated: React.Dispatch<React.SetStateAction<boolean>>;
  setUserEmailId: React.Dispatch<React.SetStateAction<string>>;
}> = ({ setAuthenticated, setUserEmailId }) => {
  const [email, setEmail] = useState<string>("");

  const forgotpassword = useSelector(
    (state: RootState) => state.authentication.forgotPassword,
  );
  const loginVideoMP4 = loginVideoUrls.LoginVideoUrl;
  const loginVideoWebM = loginVideoUrls.LoginVideoUrlWebM;

  return (
    <div
      className="login-page"
      style={{
        display: "flex",
        height: "100vh",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "fixed",
          top: "30px",
          left: "30px",
          zIndex: 20,
          width: "170px",
        }}
      >
        <img
          src={Logo}
          alt="Logo"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </div>

      <div
        className="left-pane"
        style={{
          flex: "2.2",
          // backgroundImage: `url(${figmaPageImage})`,
          // backgroundSize: 'cover',
          backgroundPosition: "center",
          height: "100vh",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <video
          autoPlay
          loop
          muted
          playsInline
          className="background-video"
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            objectFit: "fill",
          }}
        >
          <source src={loginVideoWebM} type="video/webm" />
          <source src={loginVideoMP4} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>

      <div
        className="right-pane"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <Box
          style={{
            width: "400px",
            maxWidth: "100%",
          }}
        >
          <CustomSignupForm
            email={email}
            setEmail={setEmail}
            setAuthenticated={setAuthenticated}
            setUserEmailId={setUserEmailId}
          />
        </Box>
      </div>

      {!forgotpassword && (
        <div className="absolute top-0 right-0 p-8">
          <Link to="/signup" style={{ color: "#007AFF" }}>
            Sign up
          </Link>
        </div>
      )}
    </div>
  );
};

export default SignInPage;
